/* Blusafe UK — compatibility checker: lift-lever result panel.
   When the main checker reports a compatible (or probably compatible) lift-handle
   multipoint door, the Apollo and both Origin Smart Plus handles all fit. This
   adds a panel at the top of the result that says so and sends the visitor to
   the range page. The checker itself is core-owned, so this observes its output
   rather than editing it. Config comes from window.__bsRangeCallout (region-body-end). */
(function () {
  'use strict';
  var root = document.querySelector('[data-compatibility-checker]');
  if (!root) return;
  var body = root.querySelector('[data-compatibility-body]');
  var cfg = window.__bsRangeCallout;
  if (!body || !cfg || !cfg.url || !cfg.items || !cfg.items.length) return;

  var catalog = [];
  try {
    var node = root.querySelector('[data-compatibility-catalog]');
    catalog = JSON.parse((node && node.textContent) || '[]') || [];
  } catch (e) { catalog = []; }

  function byHandle(handle) {
    for (var i = 0; i < catalog.length; i++) {
      if (catalog[i].handle === handle) return catalog[i];
    }
    return null;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (typeof text === 'string') n.textContent = text;
    return n;
  }

  function isRangeResult(shell) {
    var links = shell.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      for (var j = 0; j < cfg.items.length; j++) {
        if (href.indexOf('/products/' + cfg.items[j].handle) !== -1) return true;
      }
    }
    return false;
  }

  function track(name, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, detail || {}));
  }

  function build(status) {
    var panel = el('div', 'bs-range-callout');
    panel.appendChild(el('p', 'blusafe-compatibility__eyebrow', cfg.eyebrow || 'Compatible with all three'));
    panel.appendChild(el('h3', 'bs-range-callout__title', cfg.title || 'Based on your selection you will be compatible with any of these three.'));
    panel.appendChild(el('p', 'bs-range-callout__text', cfg.text || 'Pick based on your personal preference and bundle selection.'));

    var grid = el('div', 'bs-range-callout__grid');
    cfg.items.forEach(function (item) {
      var product = byHandle(item.handle);
      var card = el('a', 'bs-range-callout__card');
      card.href = (product && product.url) || ('/products/' + item.handle);
      if (product && product.image) {
        var media = el('span', 'bs-range-callout__media');
        var img = document.createElement('img');
        img.src = product.image; img.alt = ''; img.loading = 'lazy'; img.width = 96; img.height = 96;
        media.appendChild(img); card.appendChild(media);
      }
      var bodyEl = el('span', 'bs-range-callout__body');
      if (item.tier) bodyEl.appendChild(el('span', 'bs-range-callout__tier', item.tier));
      bodyEl.appendChild(el('span', 'bs-range-callout__name', item.name));
      if (item.note) bodyEl.appendChild(el('span', 'bs-range-callout__note', item.note));
      card.appendChild(bodyEl);
      card.addEventListener('click', function () {
        track('checker_range_product_clicked', { product_handle: item.handle, result_status: status });
      });
      grid.appendChild(card);
    });
    panel.appendChild(grid);

    var actions = el('div', 'bs-range-callout__actions');
    var cta = el('a', 'bs-btn bs-btn--primary bs-btn--md', cfg.cta || 'See all three, their accessories and bundles');
    cta.href = cfg.url;
    cta.addEventListener('click', function () {
      track('checker_range_page_clicked', { result_status: status, url: cfg.url });
    });
    actions.appendChild(cta);
    panel.appendChild(actions);
    return panel;
  }

  function apply() {
    var shell = body.querySelector('.blusafe-compatibility__result-card');
    if (!shell || shell.querySelector('.bs-range-callout')) return;
    var cls = shell.className || '';
    var status = /result-card--probably_compatible/.test(cls) ? 'probably_compatible'
      : /result-card--compatible/.test(cls) ? 'compatible' : '';
    if (!status) return;
    if (!isRangeResult(shell)) return;
    var panel = build(status);
    var anchor = shell.querySelector('.blusafe-compatibility__filter-results')
      || shell.querySelector('.blusafe-compatibility__product-grid')
      || shell.querySelector('.blusafe-compatibility__photo');
    if (anchor) shell.insertBefore(panel, anchor); else shell.appendChild(panel);
    track('checker_range_panel_seen', { result_status: status });
  }

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () { scheduled = false; apply(); });
  }).observe(body, { childList: true, subtree: true });
  apply();
})();
